import { computed, onMounted } from "vue"
import { useStore } from "vuex"
import getLabelFromStore from '../../foundation/js/getLabel'

export default {
    name: "NotificationList",
    props: {
        guid: {
            type: String,
            required: true
        },
        skip: {
            type: Number,
            default: 0
        },
        take: {
            type: Number,
            default: 10
        }
    },
    setup(props) { 
        const store = useStore()

        const notifications = computed(() => store.state.search.results[props.guid] ?? [])
        const totalNumberOfNotifications = computed(() => store.state.search.scoped_total[props.guid] ?? 0)
        const showSpinner = computed(() => store.state.search.search_inprogress[props.guid])

        onMounted(() => {
            store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: props.take,
                showMorePageSize: props.take,
                url: process.env.GET_FORUM_NOTIFICATIONS
            })
            
            store.dispatch('search/performSearch', {
                guid: props.guid,
                query: '',
                skip: props.skip,
                take: props.take
            })
        })

        const getLabel = (key, strings) => {
            let label = getLabelFromStore({
                labelKey: key,
                labelCollection: 'notificationList'
            })

            if (strings) {
                strings.forEach((str, index) => {
                    label = label.replace(`{${index}}`, str)
                })
            }

            return label
        }

        const getMoreNotifications = () => {
            store.dispatch('search/performMoreSearch', { guid: props.guid })
        }

        const rejectNotification = (notificationId) => {
            store.dispatch('forum/rejectNotification', { notificationId: notificationId, callback: updateList})
        }

        const approveNotification = (notificationId) => {
            store.dispatch('forum/approveNotification', { notificationId: notificationId, callback: updateList})
        }

        const updateList = () => {
            store.dispatch('search/performSearch', {
                guid: props.guid,
                guery: '',
                skip: 0,
                take: notifications.value.length 
            })
        }

        return {
            notifications,
            totalNumberOfNotifications,
            showSpinner,
            getMoreNotifications,
            getLabel,
            rejectNotification,
            approveNotification
        }
    }
}